<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-header class="ask-subject" :style="communityStyle" v-text="$lodash.has(community, 'name') ? community.name + ': ' + ask.subject : ask.subject">
			</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" v-on:chosen="addSeeker" editAsk="true">Ask detail goes here...</ask-detail>
		<md-card class="mt-30">
			<md-card-header>
				<div class="md-title">Current Tags:</div>
			</md-card-header>
			<md-card-content>
				<md-chips class="md-accent" v-model="ask.tags" md-deletable md-placeholder="Add tag..."></md-chips>
				<div class="md-title">Suggested Tags:</div>
				<md-chips v-model="suggestedTags" @md-click="addSuggested" md-static md-clickable></md-chips>
			</md-card-content>
			<md-ripple>
				<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
			</md-ripple>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import axios from "axios";
import API from "../services/API";
import AskDetail from "./AskDetail";
import Comments from "./Comments";
import ActivityLog from "./ActivityLog";
import AskFeedback from "./AskFeedback";
export default {
  components: {
    AskDetail,
    Comments,
    ActivityLog,
    AskFeedback
  },
  name: "Tag",
  data() {
    return {
      api: new API(),
      ask: {},
      createdByMember: {},
      action: "tag",
      suggestedTags: [],
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      },
      community: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData: async function() {
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
        this.ask = ask.data;
        if (this.ask) {
          this.createdByMember = this.ask.createdByMemberID
          await axios
            .post(
              `https://language.googleapis.com/v1/documents:analyzeEntities?fields=entities&key=${
                process.env.NLP_API_KEY
              }`,
              {
                document: {
                  content: this.ask.text,
                  language: "en",
                  type: "PLAIN_TEXT"
                },
                encodingType: "UTF16"
              }
            )
            .then(nlp => {
               var entities = nlp.data.entities;
               entities = this.$lodash.uniqBy(entities, 'name');
			   entities.map(entity => {
                this.suggestedTags.push(entity.name);
              });
            });
            this.community = this.ask.community;
          if (this.$lodash.has(this.community, 'customSettings')) {
          	this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
          	this.communityStyle.color = this.community.customSettings.secondaryColor;
          }
        }
      });
    },
    addSuggested: function(tag, i) {
      this.ask.tags.push(tag);
    },
    doInteraction: async function() {
      await this.api
        .post(`asks/${this.ask._id}/${this.action}`, {
          tags: this.ask.tags
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    },
    getCreatedBy: function() {
      this.createdByMember = this.ask.createdByMemberID;
    },
    addSeeker: function(members) {
      this.ask.createdByMemberID = members[0];
      this.getCreatedBy();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractTag.vue